@import '@hevoio/hevo-ui-toolkit/styles/variables';

$bar-height: 5px;

.progressBarWrapper {
  width: 200px;
  margin: 0 auto;
  display: flex;
  position: relative;
  height: $bar-height;
  border-radius: $border-radius-default;
  background-color: $divider-color;
  flex: 1;
}

.progressPercentage {
  display: flex;
  align-items: center;
  z-index: 1;
  background: $primary;
  height: $bar-height;
  border-radius: $border-radius-default;
  transition: width 0.5s ease-in-out;
}

.progressPercentageMinWidth {
  min-width: $bar-height;
}

.normal {
  background: $primary;
}

.success {
  background-color: $success;
}

.warning {
  background-color: $warning;
}

.deferred {
  background-color: $deferred;
}

.error {
  background-color: $error;
}
